import { render, staticRenderFns } from "./entryGoods.vue?vue&type=template&id=264aea9e&scoped=true"
import script from "./entryGoods.vue?vue&type=script&lang=js"
export * from "./entryGoods.vue?vue&type=script&lang=js"
import style0 from "./entryGoods.vue?vue&type=style&index=0&id=264aea9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264aea9e",
  null
  
)

export default component.exports